import React from 'react';
import { Mathround } from './Mathround';

class InventoryItem extends React.Component {
  handleSellItem = (event) => {
    event.preventDefault();
    const { redux } = this.props;
    redux.addCoinsAction(this.props.data.value * this.props.data.basePrice);
    redux.updateWeightAction(-this.props.data.weight);
    redux.removeItemFromInventoryAction(this.props.data);
  };

  onDragStart = (event) => {
    event.dataTransfer.effectAllowed = 'move';
    event.dataTransfer.setData('text', JSON.stringify(this.props));
    console.log(this.props.data.properties.type);
    return true;
  };

  render() {
    const { data, name } = this.props;
    return (
      <React.Fragment>
        {data.value ? (
          <div
            className="inventory__item"
            draggable={data.draggable}
            onDragStart={this.onDragStart}
          >
            <p className="inventory__item-title">{name}</p>
            <p className="inventory__item-value">{data.value}u</p>
            <p className="inventory__item-weight">{data.weight}wu</p>
            <a
              href="#sell"
              className="inventory__item-sell"
              onClick={this.handleSellItem}
            >
              <span className="icon icon-unit" />{' '}
              {Mathround(data.value * data.basePrice, 2)}
            </a>
          </div>
        ) : null}
      </React.Fragment>
    );
  }
}

export { InventoryItem };
